<template>
  <img
    v-if="isOnboardingRedesign"
    src="@/assets/images/fsa-hsa/fsa-store-logo-purple.png"
  >
  <img
    v-else
    src="@/assets/images/fsa-hsa/fsa-store-logo.png"
  >
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'IconFSAStoreLogo',
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
  },
};
</script>
